import React, { useEffect, useRef, useState } from "react";
import "./replyQuery.css";
import Reply from "./Reply";
import axios from "../../../../axios";
import NestedInput from "./NestedInput";
import CrossQueryAttachment from "../Create Query/CrossQueryAttachment";
import { debounce } from "@mui/material";
import assets from "../../../../assets/assets";
import { toast } from "react-toastify";

const ReplyQuery = ({
  queryStatus,
  queryId,
  filter,
  setFilter,
  reply,
  setReply,
  replyfetch,
  date1,
  arrowFetch,
  groupData,
  isGettingReply,
  isClearingSearch,
  getReplyRefetch,
}) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [nestedInput, setNestedInput] = useState(false);
  const [singleQuery, setSingleQuery] = useState({});
  const [replying, setReplying] = useState("");
  const [attachMent2, setAttachment2] = useState([]);
  const [parentReply, setParentReply] = useState("");
  const [replyAttach, setReplyAttach] = useState();
  const [deleted, setDeleted] = useState(false);
  const [attach, setAttach] = useState([]);
  const [edited, setEdited] = useState(false);
  const [isReplySending, setIsReplySending] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  const [count, setCount] = useState();
  const { date, replyText, page, limit, searchClick, sortBy, edit } = filter;
  useEffect(() => {
    const getSingleQuery = async () => {
      // setSingleQuery([]);
      await axios.get(`/api/v1/query/get/${queryId}`).then((response) => {
        setSingleQuery(response.data.data);
      });
    };
    getSingleQuery();
  }, [reply, queryId]);

  const getRefetch = async () => {
    try {
      const response = await axios.get(
        `/api/v1/query/reply/get/${queryId}?sortBy=-1`
      );
      response.data.data.length > 0 && setReply(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const replyInputRef = useRef(null);
  useEffect(() => {
    if (parentReply) {
      replyInputRef.current.focus();
    }
  }, [parentReply]);

  const getReply = async () => {
    // if (isClearingSearch) return;
    try {
      setIsGettingData(true);
      const formattedDate = date ? `&date=${encodeURIComponent(date1)}` : "";
      const formattedReplyText = replyText
        ? `&reply=${encodeURIComponent(replyText)}`
        : "";
      //Remove limit for appears all queries
      await axios
        .get(
          `/api/v1/query/reply/get/${queryId}?sortBy=-1${formattedDate}${formattedReplyText}`
        )
        .then((response) => {
          // (searchClick)&&setReply([]);

          response.data.data.length > 0 &&
            setReply((prev) => [...response.data.data, ...prev]);
        });
      setIsGettingData(false);
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getReply();
    setCount(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleted, edited, queryId, searchClick, replyfetch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (replying.trim() !== "" || attach.length > 0) {
      let newReply = {
        user_id: teacher_id,
        reply: replying,
        attachments: attach,
        attachments_sizeKb: Math.round(
          attachMent2.map((file) => file.size / 1024)
        ),
      };
      try {
        let res;
        setIsReplySending(true);
        if (parentReply) {
          res = await axios.post(
            `api/v1/query/${queryId}/${parentReply.id}/reply/create`,
            newReply
          );
        } else {
          if (newReply.reply !== "") {
            res = await axios.post(
              `api/v1/query/${queryId}/reply/create`,
              newReply
            );
          }
        }
        console.log("replyQerery", res);
        if (res) {
          setIsReplySending(false);
          setReplying("");
          setParentReply(null);
          setAttach([]);
          setNestedInput(false);
          setReply((prev) => [res.data.data, ...prev]);
          getReplyRefetch();
        }

        // eslint-disable-next-line
      } catch (error) {}
    }
  };

  const handelInfiniteScroll = async () => {
    try {
      if (
        document.getElementById("inner-scrollable-reply").clientHeight +
          document.getElementById("inner-scrollable-reply").scrollTop +
          1 >=
        document.getElementById("inner-scrollable-reply").scrollHeight
      ) {
        setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("inner-scrollable-reply");

    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [isValidFileType, setIsValidFileType] = useState(true);
  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.pptx|\.ppt|\.mp3|\.mp4)$/i;

    if (!allowedExtensions.exec(filePath.name) || attach.length > 5) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  const handleAttachment = async (files) => {
    let attachments = [];
    let totalSize = attachMent2.reduce((acc, file) => acc + file.size, 0);
    let fileCount = attach.length;
    if (files) {
      for (const file of files) {
        if (
          fileCount < 5 &&
          totalSize + file.size <= 10 * 1024 * 1024 &&
          validateFileType(file)
        ) {
          try {
            const maxSizeInMB = file.type.startsWith("image")
              ? 10
              : file.type === "audio/mpeg"
              ? 10
              : 10;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
            if (file.size > maxSizeInBytes) {
              // window.alert(`File size exceeds ${maxSizeInMB} MB for ${file.name}.`);
              setIsValidFileType(false);
              continue;
            }
            let formData = new FormData();
            formData.append("name", file.name);
            formData.append("uploadReplyAttachment", file);

            let res = await axios.post(
              `/api/v1/reply/uploadAttachment/userId/${teacher_id}`,
              formData
            );
            res && attachments.push(res.data.data);
            setAttachment2((prev) => [...prev, file]);
            totalSize += file.size;
            fileCount += 1;
          } catch (error) {
            console.log(error);
            toast.error(error.response.data.message);
          }
        } else {
          // window.alert(`File validation failed for ${file.name}.`);
          setIsValidFileType(false);
        }
      }

      if (attachments.length > 0) {
        setAttach((prev) => [...prev, ...attachments]);
      }
    }
  };
  const [loading, setLoading] = useState(false);
  const handleScroll = debounce(async (e) => {
    if (e.target.scrollTop === 0 && !loading) {
      setLoading(true);
      await setFilter((prevState) => ({
        ...prevState,
        page: prevState.page + 1,
      }));
      setLoading(false);
    }
  }, 300);
  const scrollContainerRef = useRef(null);
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      const addedHeight =
        scrollContainer.scrollHeight - scrollContainer.clientHeight;
      scrollContainer.scrollTop = addedHeight;
    }
  }, [reply]);
  return (
    <>
      <div onScroll={handleScroll} className=" w-100" ref={scrollContainerRef}>
        {reply.length > 0 ? (
          <div
            className=" m-0 w-100 orange-scrollBar"
            style={{
              height: "100%",
              overflowY: "auto",
            }}
          >
            {reply
              .slice(0)
              .reverse()
              .map((data, index) => (
                <div
                  key={`${data.id}_${index}_${reply.length}`}
                  className="d-flex mt-2  w-100"
                >
                  <Reply
                    queryStatus={queryStatus}
                    setReply={setReply}
                    setParentReply={setParentReply}
                    setNestedInput={setNestedInput}
                    setDeleted={setDeleted}
                    setEdited={setEdited}
                    reply={data}
                    setFilter={setFilter}
                    filter={filter}
                    queryId={queryId}
                    groupData={groupData}
                  />
                </div>
              ))}
          </div>
        ) : isGettingData || isGettingReply ? (
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              minHeight: "120px",
            }}
          >
            <img
              src="/gif/LoaderDot.gif"
              alt="Loading"
              style={{
                width: "100px",
                height: "110px",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)", // PERFECT CENTER
              }}
            />
          </div>
        ) : (
          <div
            className="text-center text-muted py-2"
            style={{ fontSize: "14px", minHeight: "120px" }}
          >
            No Reply Found!
          </div>
        )}
      </div>

      <span className=" count_reply_header">{`${
        singleQuery?.reply_count ? singleQuery?.reply_count : 0
      } Replies`}</span>

      {/* old UI */}
      {/* {queryStatus === "approved" && (
        <div className="mt-4 message_input_group">
          {nestedInput && (
            <NestedInput parentReply={parentReply} change={setNestedInput} />
          )}

          <form
            onSubmit={handleSubmit}
            className="border rounded p-3"
            style={{ backgroundColor: "#f9f9f9" }}
          >
            <div className="mb-2">
              <textarea
                ref={replyInputRef}
                value={replying}
                onChange={(e) => setReplying(e.target.value)}
                className="form-control"
                placeholder="Post Your Answer ..."
                maxLength={250}
                rows={2}
                style={{
                  resize: "vertical",
                  backgroundColor: "#f3f3f3",
                  borderRadius: "8px",
                  padding: "12px",
                  fontSize: "14px",
                  border: "1px solid #ccc",
                }}
              />
            </div>

            <div className="d-flex justify-content-end gap-2 align-items-center">
              {attach.length > 0 &&
                attach.map((item, index) => (
                  <CrossQueryAttachment
                    key={index}
                    indexToRemove={index}
                    attachment={item}
                    setAttachment2={setAttachment2}
                    attachMent2={attachMent2}
                    setAttach={setAttach}
                  />
                ))}

             
              <div className="d-flex align-items-center gap-3">
                <input
                  id="attachFile"
                  type="file"
                  style={{ display: "none" }}
                  onChange={(e) => handleAttachment(e.target.files)}
                />
                <label
                  htmlFor={`attachFile`}
                  style={{
                    border: "1px solid #8D4B28",
                    color: "#8D4B28",
                    backgroundColor: "white",
                  }}
                  className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold "
                >
                  <img
                    src={assets.UploadIcon}
                    height="80%"
                    width="30px"
                    alt="Attach Icon"
                    style={{
                      objectFit: "contain",
                      maxHeight: "100%",
                    }}
                  />
                </label>
              </div>

             
              <div>
                {isReplySending ? (
                  <img
                    src="/gif/Loader.gif"
                    alt="Loading"
                    style={{ width: "32px", height: "32px" }}
                  />
                ) : (
                  <>
                    <button
                      id="submitFile"
                      type="submit"
                      style={{ display: "none" }}
                    ></button>
                    <label
                      htmlFor="submitFile"
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#8c4c24",
                        color: "white",
                        padding: "6px 18px",
                        borderRadius: "6px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      Post
                    </label>
                  </>
                )}
              </div>
            </div>
          </form>
        </div>
      )} */}

      {/* new UI */}

      {queryStatus === "approved" && (
        <div className="mt-4 message_input_group">
          {nestedInput && (
            <NestedInput parentReply={parentReply} change={setNestedInput} />
          )}

          {/* ATTACHMENTS (same as before, untouched) */}
          <div className="mt-1 d-flex flex-wrap gap-2">
            {attach.length > 0 &&
              attach.map((item, index) => (
                <CrossQueryAttachment
                  key={index}
                  indexToRemove={index}
                  attachment={item}
                  setAttachment2={setAttachment2}
                  attachMent2={attachMent2}
                  setAttach={setAttach}
                />
              ))}
          </div>

          <form
            onSubmit={handleSubmit}
            className="d-flex align-items-center gap-2 p-2"
            style={{
              backgroundColor: "#f0f2f5",
              borderTop: "1px solid #ddd",
              borderRadius: "0",
            }}
          >
            {/* ATTACH BUTTON */}
            <div className="d-flex align-items-center gap-3">
              <input
                id="attachFile"
                type="file"
                style={{ display: "none" }}
                onChange={(e) => handleAttachment(e.target.files)}
              />
              <label
                htmlFor="attachFile"
                style={{
                  border: "1px solid #8D4B28",
                  color: "#8D4B28",
                  backgroundColor: "white",
                }}
                className="rounded-3 p-1 d-flex align-items-center justify-content-center poppins-semibold "
              >
                <img
                  src={assets.UploadIcon}
                  height="80%"
                  width="30px"
                  alt="Attach Icon"
                  style={{
                    objectFit: "contain",
                    maxHeight: "100%",
                  }}
                />
              </label>
            </div>

            {/* TEXTAREA + EMBEDDED SEND BUTTON */}
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <textarea
                ref={replyInputRef}
                value={replying}
                onChange={(e) => setReplying(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    document.getElementById("submitFile").click();
                  }
                }}
                className="form-control"
                placeholder="Post Your Answer ..."
                maxLength={250}
                rows={1}
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  padding: "10px 45px 10px 15px", // RIGHT padding for send icon
                  backgroundColor: "#ffffff",
                  border: "1px solid #ccc",
                  resize: "none",
                  fontSize: "14px",
                }}
              />

              {/* SEND BUTTON INSIDE TEXTAREA */}
              {isReplySending ? (
                <img
                  src="/gif/Loader.gif"
                  alt="Loading"
                  style={{
                    width: "28px",
                    height: "28px",
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
              ) : (
                <>
                  <button
                    id="submitFile"
                    type="submit"
                    style={{ display: "none" }}
                  ></button>

                  <label
                    htmlFor="submitFile"
                    style={{
                      cursor: "pointer",
                      fontSize: "22px",
                      color: "#25D366",
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      userSelect: "none",
                    }}
                  >
                    ➤
                  </label>
                </>
              )}
            </div>
          </form>
        </div>
      )}

      {!isValidFileType && (
        <p id="errorMsg">
          Please upload files with valid extensions (pdf, jpg, jpeg, png, pptx,
          ppt, mp3, mp4). The maximum upload limit is 5 files, and the total
          size should not exceed 10MB{" "}
        </p>
      )}
    </>
  );
};

export default ReplyQuery;
